import { motion } from "framer-motion";
import { SEO } from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { ProductCard, ComingSoonCard } from "@/components/ProductCard";
import { products, upcomingPlaceholder } from "@/data/products";

export default function Products() {
  return (
    <>
      <SEO
        title="Products"
        description="Explore the AI-powered apps built by Envago Labs, including Tanzeen+ — the AI-powered Islamic learning platform. More apps coming soon."
        path="/products"
      />

      <section className="relative overflow-hidden gradient-emerald">
        <div className="grain absolute inset-0 opacity-40" />
        <div className="relative mx-auto max-w-6xl px-5 pb-16 pt-36 sm:px-8 md:pt-44">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
              Products
            </span>
            <h1 className="mt-5 font-display text-5xl font-light leading-none tracking-tighter md:text-6xl">
              AI apps for everyday life.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground">
              Every Envago Labs product is crafted with the same standard of quality, design and
              responsible AI. Here's what we're building.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl space-y-6 px-5 pb-24 sm:px-8">
        {products.map((product, i) => (
          <Reveal key={product.slug} delay={i * 0.05}>
            <ProductCard product={product} featured={i === 0} />
          </Reveal>
        ))}
        <Reveal delay={0.1}>
          <ComingSoonCard
            title={upcomingPlaceholder.title}
            description={upcomingPlaceholder.description}
          />
        </Reveal>
      </section>
    </>
  );
}
